import React, {useEffect, useState} from 'react';
import "./styles.css";
import Layout from './Layout';
import CheckoutForm from './CheckoutForm';

const Payments = (props: any) => {
  const [userEmail, setUserEmail] = useState('');
  const [userName, setuserName] = useState('');

  useEffect(() => {
    const queryString = window.location.search;
    if(queryString) {
      const urlParams = new URLSearchParams(queryString);
      const email = urlParams.get('email')
      const fullName = urlParams.get('name')
      // payments?email=qa_shop@gutenbergcerts.com&name=John%20Doe
      // clear parameters
      window.history.replaceState(null, '',  window.location.pathname);
      if(email && fullName) {
        // setEmailFromParams(true);
        // setRegisterData({
        //   ...registerData,
        //   emailAddress: email,
        //   firstName: firstName,
        //   lastName: lastName,
        // })
        setUserEmail(email);
        setuserName(fullName)
        console.log('parameters: ', email, fullName)
      }
    }
  }, [])

  return (
    <Layout title="Gutenberg certificate checkout">
      {/* <CheckoutForm
        price={15}
        userName={userName}
        userEmail={userEmail}
        onSuccessfulCheckout={() => {
          console.log('success')
        }}
      /> */}
    </Layout>
  );
};

export default Payments;
